import "./ContactUs.module.css";
import Header from "../../reusable_sections/Header";
import Footer from "../../reusable_sections/Footer";
import ReachOurTeam from "./sections/ReachOurTeam";
import BookYourAppointment from "./sections/BookYourAppointment";
import CommonInquiries from "./sections/CommonInquiries";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ReachOurTeam />
      <BookYourAppointment />
      <CommonInquiries />
      <Footer />
    </div>;
}